import React from 'react';
import Skeleton from 'ati-ui-react/components/Skeleton';
import * as styles from './AppLoadingPageMobile.scss';
import RatingFirmsLoadingMobile from '../RatingFirmsLoadingMobile';
import { rowCountDefault } from '../../constants/skeletonDefaults';
import DescriptionLoadingMobile from '../DescriptionLoadingMobile';

const AppLoadingPageMobile = () => (
  <div className={styles.layout}>
    <div className={styles.content}>
      <div className={styles.rating}>
        <DescriptionLoadingMobile />
        <div className={styles.fakeFilter}>
          <Skeleton className={styles.fakeButtons1} />
          <Skeleton className={styles.fakeButtons2} />
          <Skeleton className={styles.fakeButtons3} />
        </div>
        <RatingFirmsLoadingMobile rowsCount={rowCountDefault} />
      </div>
    </div>
  </div>
);

export default AppLoadingPageMobile;
